import React from "react";

import "./Title.scss";

import questionClockImg from "../../assets/img/question-clock.svg";
import germ1Img from "../../assets/img/germ-1.svg";
import germ2Img from "../../assets/img/germ-2.svg";
import germ3Img from "../../assets/img/germ-4.svg";
import germ4Img from "../../assets/img/germ-3.svg";
import germ5Img from "../../assets/img/germ-2-yellow.svg";
import germ6Img from "../../assets/img/germ-1-brown.svg";

export default function Title() {
  return (
    <section className="title">
      <div className="title__icon">
        <img src={questionClockImg} alt="" className="img-fluid" />
      </div>
      <h1 className="title__heading">
        Why Does Contact Time Matter for Disinfection?
      </h1>
      <div className="germ-container">
        <div className="germ germ-1 rotate delay-random-1">
          <img src={germ1Img} alt="Germ" className="img-fluid" />
        </div>
        <div className="germ germ-2 rotate delay-random-2">
          <img src={germ2Img} alt="Germ" className="img-fluid" />
        </div>
        <div className="germ germ-3 rotate delay-random-3">
          <img src={germ3Img} alt="Germ" className="img-fluid" />
        </div>
        <div className="germ germ-4 rotate delay-random-4">
          <img src={germ4Img} alt="Germ" className="img-fluid" />
        </div>
        <div className="germ germ-5 rotate delay-random-5">
          <img src={germ5Img} alt="Germ" className="img-fluid" />
        </div>
        <div className="germ germ-6 rotate delay-random-6">
          <img src={germ6Img} alt="Germ" className="img-fluid" />
        </div>
      </div>
    </section>
  );
}
